

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { PersonalDetails } from '../../model/ngrx/personal-details.model';

export const ADD_PERSONAL_DETAILS = '[PERSDETAIL] Add';
export const REMOVE_PERSONAL_DETAILS = '[PERSDETAIL] Remove';

// AddPersonalDetails
export class AddPersonalDetails implements Action {
    readonly type = ADD_PERSONAL_DETAILS;

    constructor(public payload: PersonalDetails) { }
}
// RemovePersonalDetails
export class RemovePersonalDetails implements Action {
    readonly type = REMOVE_PERSONAL_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddPersonalDetails | RemovePersonalDetails;
